const routes = [
  {
    index: true,
    label: 'William Lee',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    addNav: true,
    label: 'Resume',
    path: '/resume',
  },
  {
    addNav: true,
    label: 'Research Papers',
    path: '/papers',
  },
  // {
  //   label: 'Contact',
  //   path: '/contact',
  // },
];

export default routes;
